import controller from './controller'
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { ParamTypes } from "../../../helpers/types.interfaces";
import { useEffect } from "react";
import i from "../../../translations/i";
import { Titles } from "../../../layouts/Titles";
import { Col, Row, Input, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

export const PriceTypes = observer(() => {

  useEffect(() => {
    controller.get()
  }, [])

  const buttons = [
    { title: i.t('def:actions.save'), type: 'primary', click: () => controller.save(), plan: 2 },
  ]

  return(
    <>
      <Titles
        title={i.t('def:Price types')}
        buttons={buttons}
      />

      <Row gutter={[20, 20]}>
        {/*{controller.items.map((el: any, index: number) => (*/}
        {/*  <Col span={24}>*/}
        {/*    <Row>*/}
        {/*      <Col span={10}>*/}
        {/*        <InputNumber*/}
        {/*          style={{ width: `100%` }}*/}
        {/*        />*/}
        {/*      </Col>*/}
        {/*      <Col span={10}>*/}

        {/*      </Col>*/}
        {/*      <Col span={5}>*/}
        {/*        <Button*/}
        {/*          type="dashed"*/}
        {/*          icon={<DeleteOutlined />}*/}
        {/*          danger*/}
        {/*        />*/}
        {/*      </Col>*/}
        {/*    </Row>*/}
        {/*  </Col>*/}
        {/*))}*/}
        {controller.items.map((el: any, index: number) => (
          <Col span={24}>
            <Row gutter={[15, 15]}>
              <Col span={10}>
                <label>{i.t('def:name')}</label>
                <Input
                  style={{ width: `100%` }}
                  onChange={(e: any) => el.private_name = e.target.value}
                  value={el.private_name}
                />
              </Col>
              <Col span={10}>
                <label>{i.t('priceTypes:publicName')}</label>
                <Input
                  style={{ width: `100%` }}
                  onChange={(e: any) => el.name = e.target.value}
                  value={el.name}
                />
              </Col>
              <Col span={4}>
                <Button
                  type="dashed"
                  icon={<DeleteOutlined />}
                  onClick={() => controller.delete(el.id ?? null, index)}
                  danger
                />
              </Col>
            </Row>
          </Col>
        ))}
        <Col span={24}>
          <Button onClick={() => controller.add()}>{i.t('def:actions.create')}</Button>
        </Col>
      </Row>
    </>
  )
})